module.exports = __webpack_public_path__ + "img/carlos-hevia-qhB6S2dts8A-unsplash.032b8274.jpg";